import React, { useState, useEffect } from "react";
import API from "../Service/Baseservice";
import "../ContactUs/Contact.css";
import { useNavigate, useLocation } from "react-router-dom";
import Loading from "../../Loading/loading";


const EditMap = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [languageId, setLanguageId] = useState(
        location.state?.languageId || 1
    );
    const [mapList, setmapList] = useState({});
    const [maplink, setmaplink] = useState("");
    const [preview, setpreview] = useState("");
    const [loading, setLoading] = useState(true);


    const fetchMapData = () => {
        setLoading(true);
        API.post("Map_list/condition", {
            model: "Map_list",
            language_id: languageId,
        })
            .then((res) => {
                const list = res.data?.data?.data;

                if (Array.isArray(list) && list.length > 0) {
                    const data = list[0];

                    setmapList(data);
                    setmaplink(data.embed_map_link || "");
                    setpreview(data.preview || "");
                }
            })
            .catch((err) => {
                console.error("Error fetching map data:", err);
            })
            .finally(() => {
                setLoading(false); // ✅ THIS WAS MISSING
            });

    };

    // const convertToEmbedLink = (url) => {
    //     if (!url) return "";

    //     // already embed
    //     if (url.includes("/maps/embed")) return url;

    //     // normal google maps link
    //     if (url.includes("google.com/maps")) {
    //         return `https://www.google.com/maps?q=${encodeURIComponent(url)}&output=embed`;
    //     }

    //     return "";
    // };

    // const convertToEmbedLink = (url) => {
    //     if (!url) return "";

    //     // already embed
    //     if (url.includes("/maps/embed")) return url;

    //     // extract latitude & longitude from normal maps link
    //     const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);

    //     if (match) {
    //         const lat = match[1];
    //         const lng = match[2];

    //         return `https://www.google.com/maps?q=${lat},${lng}&output=embed`;
    //     }

    //     return "";
    // };


    const convertToEmbedLink = (url) => {
        if (!url) return "";

        // language mapping
        const lang = languageId === 2 ? "fr" : "en";

        // already embed → just append language
        if (url.includes("/maps/embed")) {
            return url.includes("hl=")
                ? url
                : `${url}${url.includes("?") ? "&" : "?"}hl=${lang}`;
        }

        // extract latitude & longitude
        const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);

        if (match) {
            const lat = match[1];
            const lng = match[2];

            return `https://www.google.com/maps?q=${lat},${lng}&hl=${lang}&output=embed`;
        }

        return "";
    };


    const [errors, setErrors] = useState({
        maplink: ""
    });


    const validateForm = () => {
        let valid = true;
        let newErrors = { maplink: "" };

        if (!maplink.trim()) {
            newErrors.maplink = "Map link is required";
            valid = false;
        }
        // must be google maps link
        else if (!maplink.includes("google.com/maps")) {
            newErrors.maplink = "Please enter a valid Google Maps link";
            valid = false;
        }
        // must contain coordinates
        else if (!/@-?\d+\.\d+,-?\d+\.\d+/.test(maplink) && !maplink.includes("/maps/embed")) {
            newErrors.maplink = "Invalid map location link";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };


    useEffect(() => {
        fetchMapData();
    }, [languageId]);

    const [popup, setPopup] = useState({
        show: false,
        type: "",
        title: "",
        message: ""
    });

    const mapedit = async () => {

        if (!validateForm()) return;

        try {
            const res = await API.post("map_edit/update", {
                model: "map_edit",
                map_id: mapList.map_id,
                language_id: languageId,
                contact_id: mapList.contact_id,
                embed_map_link: maplink,
                preview: preview,
                active: 1,
                updatedBy: 1,
            });

            setPopup({
                show: true,
                type: "success",
                title: "Success",
                message: "Map information updated successfully!"
            });

        } catch (err) {
            console.error(err);
            setPopup({
                show: true,
                type: "error",
                title: "Failed",
                message: "Map update failed. Try again!"
            });
        }
    };

    return (
        <div className="newss-containeradd">
            {/* HEADER */}

            <div className="edit-eligibility-header-bar">
                <h2 className="services-title1">Edit Map</h2>

                <div className="header-right">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                value={languageId}
                                className="input-field"
                                onChange={(e) => setLanguageId(Number(e.target.value))}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button className="language-save-btn" onClick={mapedit}>
                        Save
                    </button>
                    <button className="language-save-btn" onClick={() => navigate("/contactus")}>
                        Back
                    </button>
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (

                <div className="edit-map-containers">
                    {/* Embed Map Link */}
                    <div className="form-group1">
                        <label>
                            Embed Map Link <span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Paste Google Maps embed link"
                            value={maplink}
                            onChange={(e) => setmaplink(e.target.value)}
                        />
                        {errors.maplink && (
                            <p className="error-texts">{errors.maplink}</p>
                        )}
                    </div>

                    {maplink && convertToEmbedLink(maplink) && (
                        <iframe
                            src={convertToEmbedLink(maplink)}
                            width="100%"
                            height="400"
                            style={{ border: 0, borderRadius: "12px", marginTop: "16px" }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Map Preview"
                        />
                    )}

                </div>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                         <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/contactus");
                                    }
                                }}
                            >
                                OK
                            </button>
                    </div>
                </div>
            )
            }

        </div>
    );
};

export default EditMap;
